import React from "react";
import { withNavBars } from "../../HOCs";
import CostingApproval from "./costingApproval";

class CostingApprovalParent extends React.Component {
  render() {
    return <CostingApproval />;
  }
}
const props = {
  boxShadow: false,
};
export default withNavBars(CostingApprovalParent, props);